import { _basePortalApi } from "./base";

export const portalReadyApi = _basePortalApi.injectEndpoints({
  endpoints: (builder) => ({
    ready: builder.query<
      { jigsawMinSoftwareVersion: string; version: string; commit: string },
      void
    >({
      query: () => ({
        url: `ready`,
      }),
    }),
  }),
});

export const portalReadyEndpoints = portalReadyApi.endpoints;
